import orderService from '../../services/orderService';
import { showNotification } from '../reducers/uiReducer';

// Types d'actions
export const FETCH_ORDERS_REQUEST = 'FETCH_ORDERS_REQUEST';
export const FETCH_ORDERS_SUCCESS = 'FETCH_ORDERS_SUCCESS';
export const FETCH_ORDERS_FAILURE = 'FETCH_ORDERS_FAILURE';

export const FETCH_ORDER_REQUEST = 'FETCH_ORDER_REQUEST';
export const FETCH_ORDER_SUCCESS = 'FETCH_ORDER_SUCCESS';
export const FETCH_ORDER_FAILURE = 'FETCH_ORDER_FAILURE';

export const UPDATE_ORDER_REQUEST = 'UPDATE_ORDER_REQUEST';
export const UPDATE_ORDER_SUCCESS = 'UPDATE_ORDER_SUCCESS';
export const UPDATE_ORDER_FAILURE = 'UPDATE_ORDER_FAILURE';

export const CANCEL_ORDER_REQUEST = 'CANCEL_ORDER_REQUEST';
export const CANCEL_ORDER_SUCCESS = 'CANCEL_ORDER_SUCCESS';
export const CANCEL_ORDER_FAILURE = 'CANCEL_ORDER_FAILURE';

export const APPEND_ORDERS_REQUEST = 'APPEND_ORDERS_REQUEST';
export const APPEND_ORDERS_SUCCESS = 'APPEND_ORDERS_SUCCESS';
export const APPEND_ORDERS_FAILURE = 'APPEND_ORDERS_FAILURE';

export const CLEAR_ORDER_ERRORS = 'CLEAR_ORDER_ERRORS';
export const REMOVE_ORDER_FROM_LIST = 'REMOVE_ORDER_FROM_LIST';

// Actions creators
export const fetchOrdersRequest = () => ({
  type: FETCH_ORDERS_REQUEST
});

export const fetchOrdersSuccess = (orders) => ({
  type: FETCH_ORDERS_SUCCESS,
  payload: orders
});

export const fetchOrdersFailure = (error) => ({
  type: FETCH_ORDERS_FAILURE,
  payload: error
});

export const fetchOrderRequest = () => ({
  type: FETCH_ORDER_REQUEST
});

export const fetchOrderSuccess = (order) => ({
  type: FETCH_ORDER_SUCCESS,
  payload: order
});

export const fetchOrderFailure = (error) => ({
  type: FETCH_ORDER_FAILURE,
  payload: error
});

export const updateOrderRequest = () => ({
  type: UPDATE_ORDER_REQUEST
});

export const updateOrderSuccess = (order) => ({
  type: UPDATE_ORDER_SUCCESS,
  payload: order
});

export const updateOrderFailure = (error) => ({
  type: UPDATE_ORDER_FAILURE,
  payload: error
});

export const cancelOrderRequest = () => ({
  type: CANCEL_ORDER_REQUEST
});

export const cancelOrderSuccess = (order) => ({
  type: CANCEL_ORDER_SUCCESS,
  payload: order
});

export const cancelOrderFailure = (error) => ({
  type: CANCEL_ORDER_FAILURE,
  payload: error
});

export const clearOrderErrors = () => ({
  type: CLEAR_ORDER_ERRORS
});

export const removeOrderFromList = (orderId) => ({
  type: REMOVE_ORDER_FROM_LIST,
  payload: orderId
});

// Action creators asynchrones
export const getOrders = (params) => async (dispatch) => {
  try {
    dispatch(fetchOrdersRequest());

    const response = await orderService.getOrders(params);

    const formattedData = {
      items: response.orders || [],
      pagination: response.pagination || {}
    };

    dispatch(fetchOrdersSuccess(formattedData));
    return Promise.resolve(formattedData);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de la récupération des commandes';
    dispatch(fetchOrdersFailure(errorMessage));
    dispatch(showNotification({ type: 'error', title: 'Erreur', message: errorMessage }));
    return Promise.reject(error);
  }
};

export const loadMoreOrders = (params) => async (dispatch) => {
  try {
    dispatch({ type: APPEND_ORDERS_REQUEST });

    const response = await orderService.getOrders(params);

    const formattedData = {
      items: response.orders || [],
      pagination: response.pagination || {}
    };

    dispatch({ type: APPEND_ORDERS_SUCCESS, payload: formattedData });
    return Promise.resolve(formattedData);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors du chargement';
    dispatch({ type: APPEND_ORDERS_FAILURE, payload: errorMessage });
    return Promise.reject(error);
  }
};

export const getOrderById = (orderId) => async (dispatch) => {
  try {
    dispatch(fetchOrderRequest());
    
    const response = await orderService.getOrderById(orderId);
    
    dispatch(fetchOrderSuccess(response.order));
    return Promise.resolve(response);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de la récupération de la commande';
    dispatch(fetchOrderFailure(errorMessage));
    
    dispatch(showNotification({
      type: 'error',
      title: 'Erreur',
      message: errorMessage
    }));
    
    return Promise.reject(error);
  }
};

export const updateOrder = (orderId, orderData) => async (dispatch) => {
  try {
    dispatch(updateOrderRequest());
    
    const response = await orderService.updateOrder(orderId, orderData);
    
    dispatch(updateOrderSuccess(response.order));
    
    dispatch(showNotification({
      type: 'success',
      title: 'Succès',
      message: 'Commande mise à jour avec succès'
    }));
    
    return Promise.resolve(response);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de la mise à jour de la commande';
    dispatch(updateOrderFailure(errorMessage));
    
    dispatch(showNotification({
      type: 'error',
      title: 'Erreur',
      message: errorMessage
    }));
    
    return Promise.reject(error);
  }
};

export const cancelOrder = (orderId) => async (dispatch) => {
  try {
    dispatch(cancelOrderRequest());
    
    const response = await orderService.cancelOrder(orderId);
    
    dispatch(cancelOrderSuccess(response.order));
    
    dispatch(showNotification({
      type: 'info',
      title: 'Information',
      message: 'Commande annulée avec succès'
    }));
    
    return Promise.resolve(response);
  } catch (error) {
    const errorMessage = error.response?.data?.message || 'Erreur lors de l\'annulation de la commande';
    dispatch(cancelOrderFailure(errorMessage));
    
    dispatch(showNotification({
      type: 'error',
      title: 'Erreur',
      message: errorMessage
    }));
    
    return Promise.reject(error);
  }
};